import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Band } from './Band';
const cards = [{
  title: 'Independent evidence',
  body: 'Lentic records what happened outside the hiring decision itself.'
}, {
  title: 'Model-tested scenarios',
  body: 'Scenarios are re-tested against current frontier models and retired when the intended challenge no longer survives.'
}, {
  title: 'Human decision',
  body: 'Lentic records evidence. A named human makes and signs off the employment decision.'
}];
const LINK = 'inline-flex items-center gap-2 text-base font-semibold text-bone underline decoration-white/25 underline-offset-4 transition-colors hover:decoration-teal-light';
export function Scrutiny() {
  return <Band dark id="scrutiny" eyebrow="Built for scrutiny" title="Evidence you can inspect, not a score you have to trust." data-id="element-345" data-mp="jeaivu0z6ee3">
      <ul className="grid gap-6 md:grid-cols-3" data-id="element-346" data-mp="ndstnwz31937">
        {cards.map(card => <li key={card.title} className="border-t border-white/15 pt-6" data-id="element-347" data-mp="jgb1496yh9xz">
            <h3 className="font-display text-2xl font-light text-bone" data-id="element-348" data-mp="ei9ghjtvt2ke">
              {card.title}
            </h3>
            <p className="mt-4 max-w-[38ch] text-[17px] leading-relaxed text-bone/65" data-id="element-349" data-mp="9iemv8iq1yvn">
              {card.body}
            </p>
          </li>)}
      </ul>

      <div className="mt-12 flex flex-wrap items-center gap-x-10 gap-y-4" data-id="element-350" data-mp="ihwn2gooryh">
        <Link to="/methodology" className={LINK} data-id="element-351" data-mp="kkvmbztdvfc">
          Methodology
          <ArrowRightIcon className="h-4 w-4 text-teal-light" aria-hidden="true" data-id="element-352" data-mp="3rvuq2w0lg678" />
        </Link>
        <Link to="/compliance" className={LINK} data-id="element-353" data-mp="3myvv6b93vv7z">
          Compliance
          <ArrowRightIcon className="h-4 w-4 text-teal-light" aria-hidden="true" data-id="element-354" data-mp="3i014kn4wd2db" />
        </Link>
      </div>
    </Band>;
}